import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Input, Rate, Progress, Icon } from 'tea-component';
import { find, isEmpty } from 'lodash-es';
import { useEditSummarizeGoal } from '../hooks';
import { commonParams } from '..';
import { CodePromptDisplay } from './CodePromptDisplay';
import LineChart from '@/pages/intelligence/components/Chart/components/LineChart';
import { NoDataRefresh } from './NoDataRefresh';
import { useSafeState } from 'ahooks';
import { useSearchParamsState } from '@/pages/aigc/hooks/useQuery';
export const Refine = ({
  urlData,
  code,
  library,
  mutate,
  formatMessage,
}: any) => {
  const [text, setText] = useState('');
  const { runAsync, loading } = useEditSummarizeGoal();
  const handleModifyChart = () => {
    runAsync({
      ...commonParams,
      summary: urlData || {},
      library,
      code,
      instructions: [text],
    })
      .then((res) => {
        setText('');
        mutate(res);
      })
      .catch((e) => {
        console.log('页面 请求错误: ', e);
        Promise.reject(e);
      });
  };
  return (
    <div className="refine-container">
      <div className="refine-loading">
        {loading && <Icon type={'loading'} />}
      </div>
      <Input
        disabled={loading}
        style={{
          width: '100%',
        }}
        value={text}
        onChange={(value, context) => {
          setText(value);
        }}
        placeholder={formatMessage('change_x_axis')}
        onPressEnter={handleModifyChart}
      />
    </div>
  );
};
export const Explain = ({ data }: any) => {
  return (
    <div>
      {data?.explanations?.map((task) => (
        <div key={task.section} className="explainContainer">
          <div className="explainContainer-title">{task.section} </div>
          <div className="explainContainer-list">
            <div className="explainContainer-messages"> {task.explanation}</div>
            {task?.code !== 'None' && (
              <div className="explainContainer-code">
                <CodePromptDisplay {...{ code: task.code }} />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export const Evaluate = ({ data, formatMessage }: any) => {
  const [isActive, setIsActive] = useState(0);
  const option = {
    grid: {
      left: '3%',
      right: '4%',
      bottom: '17%',
      top: '5%',
      containLabel: true,
    },
    radar: {
      // shape: 'circle',
      splitArea: {
        show: false, // 默认显示颜色分割区域，不需要显示
      },
      splitLine: {
        // 雷达一圈圈
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#c8d1ea', // 雷达一圈圈颜色分隔线颜色
          width: 1, // 分隔线线宽
        },
      },
      shape: 'circle',
      name: {
        textStyle: {
          color: '#262832',
          borderRadius: 2,
          padding: [1, 3],
          fontSize: 15,
        },
      },
      indicator: data?.evaluations?.map((task) => ({ name: task?.dimension })),
    },
    series: {
      name: '',
      type: 'radar',
      symbol: 'none',
      tooltip: {
        trigger: 'item',
      },
      lineStyle: {
        width: 2,
      },
      areaStyle: {
        normal: {
          color: '#5086F3',
          opacity: 0.1,
        },
      },
      data: [
        {
          value: data?.evaluations?.map((task) => task?.score),
          name: '',
        },
      ],
    },
  };
  const handleOnActiveMessages = (index: number) => {
    setIsActive(index);
  };

  const calculateRating = <S extends number>(score: S, maxScore: S): S => {
    const rating = (score / maxScore) * 5;
    return rating as S;
  };
  const rankDescriptionInformation = useMemo(() => {
    return find(data?.evaluations, (_, ix) => ix === +isActive);
  }, [isActive, data?.evaluations]);
  if (isEmpty(data?.evaluations)) return <></>;
  return (
    <div>
      <div className="text-refine">{formatMessage('evaluated_across')}</div>
      <div className="evaluateContainer">
        <div className="evaluateContainer-echarts">
          <LineChart height={350} lineOption={option} />
        </div>
        <div className="evaluateContainer-right">
          {data?.evaluations?.map((task, index) => (
            <div key={task.dimension}>
              <div
                className={classNames('evaluateContainer-list', {
                  'evaluateContainer-list-hover': isActive === index,
                })}
                onClick={() => handleOnActiveMessages(index)}
              >
                <Rate
                  allowHalf
                  theme="primary"
                  defaultValue={calculateRating(task?.score * 10, 100)}
                  readonly
                />
                <div className="evaluateContainer-type"> {task.dimension}</div>
                <div className="evaluateContainer-progress">
                  <Progress
                    percent={task?.score * 10}
                    theme={task?.score * 10 > 50 ? 'success' : 'danger'}
                    text=""
                  />
                </div>
              </div>
            </div>
          ))}
          <div className="evaluateContainer-rank">
            <div>
              <div className="evaluateContainer-bugs">
                {rankDescriptionInformation?.dimension}
              </div>
              <div className="evaluateContainer-number">
                {calculateRating(rankDescriptionInformation?.score * 10, 100)}
              </div>
              <div className="evaluateContainer-total">{'out of 5'}</div>
            </div>
            <div className="evaluateContainer-rank-messages">
              {rankDescriptionInformation?.rationale}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const Recommend = ({ data, expleanRefresh }: any) => {
  const hanldeRefreshPromise = () => {
    expleanRefresh();
  };
  return (
    <div className="recommendContainer">
      {data?.charts?.map((task) => (
        <div className="recommendContainer-list">
          <div className="recommendContainer-img">
            <NoDataRefresh
              {...{
                hanldeRefreshPromise,
                refReshLoaidng: false,
                imgSrc: task?.raster,
              }}
            />
          </div>
          <div className="recommendContainer-right">
            <CodePromptDisplay {...{ code: task.code }}></CodePromptDisplay>
          </div>
        </div>
      ))}
    </div>
  );
};
